import React from 'react';
import type { DataflowExecutiveRibbonData } from '../../services/dataflowExecutiveDiagnostics';
import { TPL_SEVERITY_STYLE } from '../../services/tplSeverityStyles';
import { DataflowExecutiveRibbon } from './DataflowExecutiveRibbon';

interface DataflowExecutiveDiagnosisProps {
  ribbon: DataflowExecutiveRibbonData;
  situationLabel?: string;
}

/** Nível 1 — Diagnóstico Executivo (situação atual). */
export const DataflowExecutiveDiagnosis: React.FC<DataflowExecutiveDiagnosisProps> = ({
  ribbon,
  situationLabel,
}) => {
  const style = TPL_SEVERITY_STYLE[ribbon.status.tone];

  return (
    <section className={`rounded-lg border px-3 py-2 ${style.border} ${style.bg}`}>
      <div className="mb-1.5 flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-[9px] font-bold uppercase tracking-widest text-[#2F6FED]">
            Diagnóstico Executivo
          </p>
          <p className={`text-[12px] font-bold ${style.text}`}>
            Situação atual: {situationLabel ?? ribbon.status.label}
          </p>
        </div>
      </div>
      <DataflowExecutiveRibbon data={ribbon} compact />
      {ribbon.status.tone !== 'normal' && ribbon.status.reasons.length > 0 && (
        <div className="mt-2 border-t border-slate-200/60 pt-2 dark:border-slate-700/60">
          <p className="text-[9px] font-bold uppercase tracking-wide text-slate-500">Motivos</p>
          <ul className="mt-1 space-y-0.5">
            {ribbon.status.reasons.map((reason) => (
              <li key={reason} className={`text-[11px] font-medium ${style.text}`}>
                • {reason}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default DataflowExecutiveDiagnosis;
